import { Check } from '@mui/icons-material';
import {
  Autocomplete,
  Button,
  DialogActions,
  DialogContent,
  ListItem,
  ListItemText,
  TextField,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { DraggableDialog } from '~/components/Dialogs/components/DraggableDialog';
import { SolaForceDialogTitle } from '~/components/SolaForceDialogTitle';
import { CompanyDataLanguage } from '~/data/company';
import { LegacyFAIcon, LegacyFAIcons } from '~/legacy-components/LegacyFAIcon';

import { useChangeLanguage } from './useChangeLanguage';

type Props = {
  resetDialog: () => void;
};

export const ChangeLanguage = (props: Props) => {
  const {
    companyDataLanguages,
    isChangeLanguageDialogOpen,
    onSubmit,
    language,
    onChange,
    onClose,
    isSubmitting,
    isCurrentLanguage,
    currentLanguage,
  } = useChangeLanguage(props);

  const { t } = useTranslation();

  return (
    <DraggableDialog open={isChangeLanguageDialogOpen} onClose={onClose}>
      <SolaForceDialogTitle
        icon={<LegacyFAIcon FAIcon={LegacyFAIcons.Globe} />}
        onClose={onClose}
      >
        {t('laChangeLanguage')}
      </SolaForceDialogTitle>
      <DialogContent dividers={true}>
        <Autocomplete
          options={companyDataLanguages || []}
          getOptionLabel={(c) => c.fComLanguageName}
          renderOption={(props, option) => {
            return (
              <ListItem {...props}>
                <ListItemText>{option.fComLanguageName}</ListItemText>
                {option.fComLanguageCode === currentLanguage && <Check />}
              </ListItem>
            );
          }}
          onChange={(e, value) => {
            onChange(value ? value.fComLanguageCode : '');
          }}
          value={
            (companyDataLanguages as CompanyDataLanguage[]).find(
              (op) => op.fComLanguageCode === language,
            ) || undefined
          }
          disabled={isSubmitting}
          disableClearable={true}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={t('laChooseLang')}
              label={t('laLanguage')}
              InputLabelProps={{ shrink: true }}
            />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onSubmit} disabled={isSubmitting || isCurrentLanguage}>
          {t('save')}
        </Button>
      </DialogActions>
    </DraggableDialog>
  );
};
